import { useParams } from 'react-router';
import Main from '../../frame/main/Main';
import MaxWidthWrapper from '../../components/max-width-wrapper/MaxWidthWrapper';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchSchoolEventIfSchoolIsRegistered } from '../school-event-actions';
import Loading from '../../components/Loading';
import SchoolEventSchoolPageOD from './SchoolEventSchoolPageOD';
import SchoolHasNotJoinedEvent from '../school-event-elements/SchoolHasNotJoinedEvent';
import { trackPageView } from '../../support-and-tracking/analytics-actions';

const SchoolEventSchoolPage = () => {
    const { eventId, schoolOrgId } = useParams();
    const dispatch = useDispatch();
    const schoolEvents = useSelector((state) => state.schoolEvents);
    const [schoolEventData, setSchoolEventData] = useState();
    const [loading, setIsLoading] = useState(true);

    useEffect(() => {
        dispatch(fetchSchoolEventIfSchoolIsRegistered({ eventId, schoolOrgId }))
            .then((res) => {
                setSchoolEventData(res.body);
            })
            .finally(() => setIsLoading(false));
        trackPageView({
            urlAsEvent: 'school-event-school-page',
            properties: {
                'event-id': eventId,
                'school-org-id': schoolOrgId,
            },
        });
    }, [eventId, schoolOrgId]);

    if (loading) {
        return (
            <Main>
                <MaxWidthWrapper>
                    <Loading />
                </MaxWidthWrapper>
            </Main>
        );
    }

    if (Object.keys(schoolEventData)?.length === 0 && !loading) {
        return <SchoolHasNotJoinedEvent />;
    }

    if (eventId === schoolEvents.od2022) {
        return <SchoolEventSchoolPageOD schoolEventData={schoolEventData} />;
    } else {
        return <SchoolHasNotJoinedEvent />;
    }
};

export default SchoolEventSchoolPage;
